export default "__VITE_ASSET__BnfieGtI__"